<template>
  <div id="access-result">
    <div class="access-result-content ipub-shadow">
      <div class="ipub-p1 mar-b-12"
           style="font-size:20px">Welcome to</div>
      <img class="access-result-content__logo mar-b-80"
           :src="`${domain}/${publisherInfo.logo}`"
           alt="">
      <div class="access-result-content__mail flex-center mar-b-20">
        <div>
          <ipub-icon class="warning-color"
                     type="icona-QA" />
        </div>
        <div class="ipub-h2 font-color-l mar-l-20">You need to vertify your email address ({{email}}) to activate your account.</div>
      </div>
      <div style="font-size:16px"
           class="font-color ipub-p2 mar-b-30">
        An email with instructins to vertify your email address has been sent to you.
      </div>
      <div class="ipub-p1 font-color">
        Haven’t received a vertification note in your email?
      </div>
      <div class="ipub-p2 font-color">
        <a class="link-color ipub-p1"
           v-if="!loading"
           @click="resend">Send it again </a>
        <font class="font-color-l"
              v-else>Try sending again after {{time}} seconds</font>
        or check your spam
      </div>
    </div>
    <div class="access-footer ipub-p3">
      {{publisherInfo.copyright || '©2022 IMR Press.'}}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
